export default __webpack_public_path__ + "static/media/Rue.97bfd44f.jpg";